import { QueryClient } from '@tanstack/svelte-query'

const queryClient = new QueryClient()

export { queryClient }
